import * as React from "react";
import Checkbox from "@8x8/oxygen-checkbox";
import NodeState from "../types/nodeState";
import styled from "styled-components";

const StyledCheckbox = styled(Checkbox)`
  margin-left: calc(${({ level }) => level} * 16px);
`;

const TreeNode = ({ displayName, id, nodeState, level, toggle }) => {
  const isChecked = nodeState === NodeState.CHECKED;
  const isIndeterminate = nodeState === NodeState.INDETERMINATE;

  return (
    <StyledCheckbox
      level={level}
      label={displayName}
      value={id}
      isChecked={isChecked}
      isIndeterminate={isIndeterminate}
      onChange={() => toggle(id)}
    />
  );
};

export default TreeNode;
